export default __webpack_public_path__ + "static/media/retiro_seclantas3.9abb3f04.jpg";